/* eslint-disable @typescript-eslint/ban-ts-comment */
import {
  Button,
  ButtonGroup,
  Input,
  ModalIcon,
  Spacer,
  Stack,
  TextBody,
  TextTitle,
} from '@pypestream/design-system';
import { FC, useState } from 'react';

import { GenericModal, GenericModalProps } from '..';
import {
  sendProStudioEvent,
  useProStudioStateMatches,
} from '../../../xstate/app.xstate';

export interface DeleteRuleSetModalProps extends GenericModalProps {
  ruleSetId?: string;
  ruleSetName?: string;
}

export const DeleteRuleSetModal: FC<DeleteRuleSetModalProps> = ({
  modalRef,
  onClose: onCloseProp,
  ruleSetId,
  ruleSetName = '',
}) => {
  const isDeleting = useProStudioStateMatches(
    'checkingUserInfo.projectFlow.projectDataLoaded.botFlow.deletingPypeRuleGroupFlow'
  );

  const [inputValue, setInputValue] = useState('');

  const onClose = () => {
    setInputValue('');
    onCloseProp?.();
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleDelete = () => {
    if (!ruleSetId || inputValue.trim() !== ruleSetName) {
      return;
    }

    sendProStudioEvent({
      type: 'deletePypeRuleGroup',
      payload: { id: ruleSetId, cb: onClose },
    });
  };

  return (
    <GenericModal
      test-id="delete-rule-set-modal"
      modalRef={modalRef}
      onClose={onClose}
      hideCloseBtn={isDeleting}
      stayOnClickOutside={isDeleting}
    >
      <Stack justifyContent="center">
        <ModalIcon name="error" />
      </Stack>
      <TextTitle size="small" textAlign="center">
        Delete this Rule Set?
      </TextTitle>
      <Spacer size="small" />
      <TextBody
        test-id="delete-rule-set-modal-subtitle"
        variant="secondary"
        textAlign="center"
      >
        Any channel currently using this rule set will fall back to the project
        default and start masking data according to those patterns instead.
      </TextBody>
      <Spacer size="large" />
      <TextBody test-id="delete-rule-set-modal-verify-text" variant="secondary">
        To verify, type <span color="warning">&ldquo;{ruleSetName}&rdquo;</span>{' '}
        below
      </TextBody>
      <Spacer size="2xsmall" />
      <Input
        test-id="delete-rule-set-modal-input"
        variant="outlined"
        value={inputValue}
        onChange={handleInputChange}
        // @ts-ignore
        onInput={handleInputChange}
        disabled={isDeleting}
        name="rule-set-name"
      />
      <ButtonGroup slot="footer">
        <Button
          test-id="delete-rule-set-modal-cancel-button"
          width="full"
          variant="secondary"
          size="large"
          onClick={onClose}
          disabled={isDeleting}
        >
          Cancel
        </Button>
        <Button
          test-id="delete-rule-set-modal-delete-button"
          width="full"
          variant="warning"
          size="large"
          onClick={handleDelete}
          disabled={isDeleting || inputValue.trim() !== ruleSetName}
        >
          Delete
        </Button>
      </ButtonGroup>
    </GenericModal>
  );
};
